import React from 'react';
import { Link } from 'react-router-dom';

const TheBodyDelighted = ({ cursorVisibility }) => {
  return (
    <Link id={cursorVisibility} className='The-body-delighted link none' to=''>
      <p>The body, delighted by being unlocatable, exhaling</p>
      <p className='half'>
        {' '}
        from behind the flow of a veil, acquired for itself
      </p>
      <p className='half'>
        the virginity of a foreign site displayed under a fermata.
      </p>
      <br />
      <p>Guts, no sooner scattered, spring forth incidentally sovereign</p>
      <p className='half'>—blown from where?</p>
      <br />
      <p>Retreats of a skirt and herself instituting a place.</p>
      <p className='half'>All distractions from life pulled in, communicated</p>
      <p className='half'>
        to impersonal, eurythmic surfaces of steamy semi-nudes.
      </p>
      <br />
      <p>
        Chastity is a qualifier—being split open, relieved of the weight of its
        flesh.
      </p>
      <br />
      <p>
        The formula of self-coronation masks the marginal exorbitance of a
        relational act.
      </p>
      <br />
      <p>
        Myth-sized life folds into doctrine, laid on the bed of sebum silks.
      </p>
    </Link>
  );
};

export default TheBodyDelighted;
